import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deploymentPopupTitle: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.deployment-popup-title',
		defaultMessage: 'Deployment',
		description:
			'Title of the popup indicating that the details of the popup represent a deployment.',
	},
	viewAllDeployments: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.view-all-deployments',
		defaultMessage: 'View all deployments',
		description:
			'Clickable text to open the detail development information dialog to show all the deployments, and others.',
	},
	issuesDeployed: {
		id: 'software-releases-launch-card.latest-deployment.deployment-tooltip-content.issues-deployed',
		defaultMessage: '{issueCount} {issueCount, plural, one {issue} other {issues}} deployed',
		description:
			'Clickable text to open the detail development information dialog to show all the deployments, and others.',
	},
});
